<template>
    <div class="ui-content dashboard">
        <div class="page-user user">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab key="OngoingTests" :href="'#OngoingTests'">Ongoing Tests</v-tab>
                <v-tab key="UpcomingTests" :href="'#UpcomingTests'">Upcoming Tests</v-tab>
                <v-tabs-items :touchless="true" v-model="tab">
                    <template v-if="getAccessToSchedule()">
                        <!-- coordinator -->
                        <v-tab-item key="UpcomingTests" :value="'UpcomingTests'">
                            
                                <CoordinatorUpcomingTests category="UPCOMING" :tab="tab" :value="'UpcomingTests'" />
                            
                        </v-tab-item>
                        <v-tab-item key="OngoingTests" :value="'OngoingTests'">
                            
                                <CoordinatorUpcomingTests category="ONGOING" :tab="tab" :value="'OngoingTests'" />
                          
                        </v-tab-item>
                    </template>
                    <template v-else-if="user && roleIds.ST === user.role_id">
                        <!-- student -->
                        <v-tab-item key="OngoingTests" :value="'OngoingTests'">
                            
                                <StudentUpcomingTests category="ONGOING" :tab="tab" :value="'OngoingTests'" />
                            
                        </v-tab-item>

                        <v-tab-item key="UpcomingTests" :value="'UpcomingTests'">
                           
                                <StudentUpcomingTests category="UPCOMING" :tab="tab" :value="'UpcomingTests'" />
                            
                        </v-tab-item>
                    </template>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
    
</template>

<script>
import CoordinatorUpcomingTests from "@/components/coordinator/Tests/UpcomingTests.vue";
import StudentUpcomingTests from "@/components/student/Tests/UpcomingTests.vue";

import { mapActions, mapState, mapMutations } from "vuex";
export default {
    name: "ScheduleTests",
    components: {
        CoordinatorUpcomingTests,
        StudentUpcomingTests
    },
    data() {
        return {
            tab: null,
            right: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            grow: false,
            icons: false,
            centered: false,
        };
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
    mounted() {
        this.defaultData();
        this.checkSessionData()

    },
    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName); 
            if(crd) {
                this.tab = crd.selectedTab ? crd.selectedTab : 'OngoingTests';
            }
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            
            if(rp.params.resetPage || !crd.routeName) {
                let orderField = this.roleIds.ST === this.user.role_id ? 'test_name' : 'alt_test_name';
                let tabDetail = {
                    UpcomingTests: {
                            page: 1,
                            orderBy: {
                                field: orderField,
                                order: "ASC"
                            }
                        },
                    OngoingTests: {
                            page: 1,
                            orderBy: {
                                field: orderField,
                                order: "ASC"
                            }
                        }
                };
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                    tabDetails: tabDetail
                }
                this.setRouteDetails(routeDetails);
            }
        },
        getAccessToSchedule(){
            return this.user &&(this.roleIds.CO ===  this.user.role_id|| this.roleIds.ID ===  this.user.role_id ||  this.roleIds.ED ===  this.user.role_id||  this.roleIds.PA ===  this.user.role_id)
        },
    },
    watch: {
        tab(val, oldVal) {
            if(oldVal) { // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({routeName, selectedTab: val});
            }
            let title = "Upcoming Tests";
            if (val === "UpcomingTests") {
                title = "Upcoming Tests";
            } else if (val === "OngoingTests") {
                title = "Ongoing Tests";
            }

            this.addBreadCrumbChilde([
                {
                    text: title,
                    disabled: false
                }
            ]);
        }
    }
};
</script>